import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import './css/variables.css';
import './css/common.css';
import './css/Login.css';
import './css/ForgotPassword.css';
import './css/UserSignup.css';
import './css/LegalPage.css';
import './css/OAuthCallback.css';
import './css/AppHeader.css';
import './css/Landing.css';
import './css/WorkMockExample.css';
import './css/Shinjin.css';
import './css/Home.css';
import './css/LlmPractice.css';
import './css/CodeBlock.css';
import './css/Prompt.css';
import './css/Knowledge.css';
import './css/Mcp.css';
import './css/Agent.css';
import './css/AgentShowcase.css';
import './css/AgentSharePage.css';
import './css/ShareModal.css';
import './css/Edu.css';
import './css/Template.css';
import './css/Project.css';
import './css/Settings.css';
import './css/Billing.css';
import './css/Onboarding.css';
import './css/LoadingSpinner.css';


import './css/PartnerProjectManagement.css';
import './css/PartnerInstructorMaterials.css';

import './css/AdminLogin.css';
import './css/AdminCommon.css';
import './css/AdminStatusMonitoring.css';
import './css/AdminInstructorApproval.css';
import './css/AdminLlmManagement.css';
import './css/AdminUsageCost.css';
import './css/adminUserManagement.css';
import './css/AdminUserActivity.css';
import 'react-quill-new/dist/quill.snow.css';
import './css/AdminNoticeManagement.css';
import './css/AdminMcpToolsManagement.css';
import './css/AdminDataPipeline.css';

import './css/Station.css';
import './css/StationChat.css';


import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

const tree = (
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

// react-snap으로 prerender한 공개 경로 목록 (package.json의 reactSnap.include와 일치)
const PRERENDERED_PATHS = [
  '/', '/notice', '/pricing', '/classes', '/support',
  '/login', '/register', '/forgot-password', '/terms', '/privacy',
];

// 현재 경로가 프리렌더 대상인지 — 정적 서버(SPA fallback)에서 보호 경로 진입 시
// 루트 index.html(랜딩홈 prerender)이 그대로 내려오므로, 그 마크업을 hydrate하면
// 랜딩이 잠깐 보였다가 실제 화면으로 교체되며 깜빡인다. 공개 경로일 때만 hydrate한다.
const isPrerenderedPath = PRERENDERED_PATHS.includes(window.location.pathname);

// react-snap이 빌드 시점에 prerender한 HTML이 있고, 그 경로가 실제 프리렌더 대상이면 hydrate.
// 그 외(보호 경로 등 fallback으로 랜딩 HTML이 내려온 경우)는 마크업을 비우고 일반 render.
if (rootElement.hasChildNodes() && isPrerenderedPath) {
  ReactDOM.hydrateRoot(rootElement, tree);
} else {
  rootElement.innerHTML = '';
  ReactDOM.createRoot(rootElement).render(tree);
}

reportWebVitals();